import { buttonStyle, commonStyles } from "src/Library/CommonStyles";
import { tokens } from 'src/design-system';

export const PortSettingsSideDrawerStyles = (theme) => ({
  drawer: {
    '& .ant-drawer-body': {
      height: '100%',
      padding: 0,
    },
  },
  tabStyle: {
    padding: `${tokens.spacing.sm}px ${tokens.spacing.lg}px`,
    '& .ant-tabs-nav .ant-tabs-tab': {
      padding: `10px ${tokens.spacing.lg}px`,
      margin: 0,
      color: '#A9A9A9',
      width: '50%',
      textAlign: 'center',
      cursor: 'pointer',
    },
    '& .ant-tabs-bar': {
      marginBottom: 0,
    },
    '& .ant-tabs-nav': {
      width: '100%',
    },
    '& .ant-tabs-nav .ant-tabs-tab-active': {
      color: tokens.colors.textSecondary,
      fontWeight: 'bold',
      '&:hover': {
        color: tokens.colors.textSecondary,
      },
    },
    '& .ant-tabs-ink-bar ': {
      backgroundColor: tokens.colors.textSecondary,
      height: '2px',
    },
  },
  portAxis: {
    fontSize: tokens.fontSize.caption,
    fontWeight: 'normal',
    color: '#A9A9A9',
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    backgroundColor: tokens.colors.bgWhite,
    width: '100%',
    padding: tokens.spacing.lg,
    borderTop: '1px solid #D9D9D9',
  },
  confirmButton: {
    ...buttonStyle(tokens.colors.bgWhite, tokens.colors.primaryDark, `1px solid ${tokens.colors.primaryDark}`),
  },
  select: {
    width: '100%',
    marginTop: '20px',
    '& .ant-select-selection': {
      border: 'unset',
      borderBottom: '1px solid #D9D9D9',
      boxShadow: 'unset !important',
      borderRadius: 0,
    },
    '& .ant-select-selection--multiple .ant-select-selection__placeholder': {
      fontSize: tokens.fontSize.small,
    },
  },
  dryPort: {
    backgroundColor: '#DBECFB',
    color: '#1C4B78',
    fontSize: tokens.fontSize.caption,
    border: '1px solid #1C4B78',
    borderRadius: tokens.radius.sm,
    padding: '0px 3px',
    verticalAlign: 'top',
    marginLeft: tokens.spacing.sm,
  },
  cancelButton: {
    ...buttonStyle(tokens.colors.primaryDark, tokens.colors.bgWhite, `1px solid ${tokens.colors.primaryDark}`),
    marginLeft: tokens.spacing.sm,
    padding: '0 20px',
  },
  portRow: {
    borderRadius: tokens.radius.md,
    fontSize: tokens.fontSize.small,
    margin: '2px 0',
    cursor: 'pointer',
    ...commonStyles(theme).flexRow,
    '& #remove': {
      display: 'none',
    },
    '& #defaultDragIcon': {
      display: 'inline',
    },
    '& #dragIconOnHover': {
      display: 'none',
    },
    '&:hover': {
      '& #remove': {
        display: 'inline',
      },
      '& #dragIconOnHover': {
        display: 'inline',
      },
      '& #defaultDragIcon': {
        display: 'none',
      },
    },
    '& .ant-col-3': {
      backgroundColor: `${tokens.colors.bgWhite} !important`,
      padding: '5px 0',
      '&:hover': {
        backgroundColor: `${tokens.colors.bgWhite} !important`,
      },
    },
    '& .ant-col-12:nth-child(odd)': {
      padding: `${tokens.spacing.xs}px 0`,
    },
    '& .ant-col-8': {
      padding: `${tokens.spacing.xs}px 0`,
    },
    '& .ant-col-1': {
      padding: `${tokens.spacing.xs}px 0`,
    },
  },
  dropdown: {
    border: '1px solid #D9D9D9',
    boxShadow: 'unset',
    '& .ant-select-dropdown-menu-item': {
        paddingRight: '8px !important',
      '& .ant-select-selected-icon': {
        display: 'none',
      },
    },
  },
  portDiv: {
    ...commonStyles(theme).justifySpaceBetween,
    alignItems: 'center',
  },
  portTitle: {
    fontSize: tokens.fontSize.caption,
    margin: '22px 0 8px 0',
    fontWeight: tokens.fontWeight.semibold,
  },
  overflowText: {
    ...commonStyles(theme).ellipses,
  },
  flexRow: {
    ...commonStyles(theme).flexRow,
  },
  oddRowStyle: {
    backgroundColor: 'rgba(227, 211, 169, 0.05)',
    '&:hover': {
      backgroundColor: 'rgba(227, 211, 169, 0.12)',
    },
  },
  evenRowStyle: {
    backgroundColor: 'rgba(253, 253, 253, 1)',
    '&:hover': {
      backgroundColor: 'rgba(246, 247, 250, 0.8)',
    },
  },
});
